// import type { NestingLabel } from 'types/track'

type NestingLabel = string

export const A_CAPPELLA = 'A cappella'
export const CLEAN = 'Clean'
export const CUTDOWN = 'Cutdown'
export const DEMO = 'Demo'
export const EDIT = 'Edit'
export const EXPLICIT = 'Explicit'
export const INSTRUMENTAL = 'Instrumental'
export const MAIN = 'Main'
export const MIX = 'Mix'
export const OTHER = 'Other'
export const RADIO = 'Radio'
export const REMIX = 'Remix'
export const STEM = 'Stem'
export const WORKTAPE = 'Worktape'
export const NESTING_LABELS: NestingLabel[] = [
  A_CAPPELLA,
  CLEAN,
  CUTDOWN,
  DEMO,
  EDIT,
  EXPLICIT,
  INSTRUMENTAL,
  MAIN,
  MIX,
  OTHER,
  RADIO,
  REMIX,
  STEM,
  WORKTAPE,
]
export const VERSIONS_LIMIT = 20
export const STEMS_LIMIT = 100
export const ALREADY_NESTED_TRACK = 'ALREADY_NESTED_TRACK'
export const NESTED_TRACK_INTO_ANOTHER_TRACK = 'NESTED_TRACK_INTO_ANOTHER_TRACK'
export const NESTED_TRACK_ALREADY_IN_PLAYLIST =
  'NESTED_TRACK_ALREADY_IN_PLAYLIST'
export const TOO_MANY_VERSIONS = 'TOO_MANY_VERSIONS'
export const NESTED_INTO_ITSELF = 'NESTED_INTO_ITSELF'
export const VERSION_OF_MAIN_TRACK_ALREADY_IN_PLAYLIST =
  'VERSION_OF_MAIN_TRACK_ALREADY_IN_PLAYLIST'
